import { Component, ElementRef, HostListener, inject, Input, OnInit } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { EVENT } from '@app/analytics/analytics.cnst'
import { AnalyticsService } from '@app/analytics/analytics.service'
import { loader, LoaderType } from '@app/decorators/decorators'
import { LoaderDirective } from '@app/dir/loader/loader.directive'
import { BaseModal } from '@app/pages/base.modal'
import { TrPipe } from '@app/pipes/tr.pipe'
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonLabel,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone'
import { NCShare } from '@src/typings/capacitor.js'

@Component({
  selector: 'app-social-modal',
  templateUrl: './social.modal.html',
  styleUrls: ['./social.modal.scss'],
  imports: [
    LoaderDirective,
    TrPipe,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    IonContent,
    IonFooter,
    IonLabel,
  ],
})
export class SocialModal extends BaseModal implements OnInit {
  className = 'SocialModal'

  private _sanitizer = inject(DomSanitizer)
  private analyticsService = inject(AnalyticsService)

  @Input()
  private msgKey?: string

  @Input()
  public image?: string

  @Input()
  public url?: string

  @Input()
  public text?: string

  public imagePreviewSrc?: SafeUrl
  protected override elementRef: ElementRef

  constructor() {
    const elementRef = inject(ElementRef)

    super()
    this.elementRef = elementRef
  }

  ngOnInit(): void {
    if (this.image) {
      this.imagePreviewSrc = this._sanitizer.bypassSecurityTrustUrl(this.image)
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    this.dismissModalOnEvent(event)
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: MouseEvent): void {
    this.dismissModalOnEvent(event)
  }

  public override ionViewDidEnter(): void {
    super.ionViewDidEnter()
  }

  @loader(LoaderType.BUTTON)
  async share(): Promise<void> {
    void this.analyticsService.trackEvent(EVENT.SHARE_BUTTON_CLICK, {
      message: this.msgKey,
    })

    // TODO: share img
    await NCShare.share({ text: this.text, url: this.url, image: this.image })
  }

  private dismissModalOnEvent(event: MouseEvent): void {
    if (this.elementRef.nativeElement.tagName === (event.target as Element).tagName) {
      void this.dismissModal()
    }
  }
}
